import { defineStore } from "pinia";
import { useSessionStore } from "@/stores/sessionStore";
import RepositoryFactory from "@/repositories/apiGateWay/repositoryFactory";
import ApplicationError from "@/helpers/applicationError";
import {HTTP_CODE_BAD_REQUEST, HTTP_CODE_SUCCESS} from "@/data/constants";
import i18n from '@/i18n/main'

const apiGatewayRepository = RepositoryFactory.get("apiGateway");
const { t } = i18n.global;
export const useSubscriberStore = defineStore("subscribers", {
    id: "subscribers",
    state: () => {
        return {
            isLoading: false,
            subscriptions: [],
            filteredSubscriptions: [],
            errorMessage: "",
            registeredApps: [],
            filters: {
                companyAppId: null,
                nextPaymentDateFrom: null,
                nextPaymentDateTo: null,
            }
        };
    },
    persist: {
        paths: ["companyAppId", "nextPaymentDateFrom", "nextPaymentDateTo"],
    },
    getters: {
        getSession() {
            return useSessionStore().session_data;
        },
        getSubscriptions(state) {
            return state.subscriptions;
        },
        getSubscriptionFilters(state) {
            return state.filters;
        }
    },
    actions: {
        async getSubscribers() {
            try {
                this.isLoading = true;

                await apiGatewayRepository.getSubscribers({
                    'user_id' : this.getSession.hubsynch_id,
                }).then((res) => {
                    if (res.data.code === HTTP_CODE_SUCCESS) {
                        this.subscriptions = res.data.data;
                        this.filteredSubscriptions = res.data.data;
                        return false;
                    }
                }).catch((e) => {
                    const data = e.response.data;

                    if (data.code === HTTP_CODE_BAD_REQUEST && typeof data.errors === "object") {
                        this.errorMessage = Object.values(data.errors)[0];
                        this.isLoading = false;
                        return false;
                    }

                    if (data.code === HTTP_CODE_BAD_REQUEST && typeof data.errors == "string") {
                        this.errorMessage = data.errors;
                        this.isLoading = false;
                        return false;
                    }

                    this.isLoading = false;
                    throw new ApplicationError();
                });

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                throw new ApplicationError(error.message, [this.getSession.hubsynch_id], error);
            }
        },
        filterSubscriptions() {
            try {
                this.filteredSubscriptions = this.getSubscriptions;

                const filter = this.getSubscriptionFilters;

                if (filter.nextPaymentDateFrom && filter.nextPaymentDateTo && filter.nextPaymentDateFrom > filter.nextPaymentDateTo) {
                    this.errorMessage = t('ERROR_INVALID_NEXT_PAYMENT_DATE_RANGE');
                    return false;
                }

                if (filter.companyAppId != null) {
                    this.filteredSubscriptions = this.filteredSubscriptions.filter(s => s.company_app_id === filter.companyAppId);
                }

                if (filter.nextPaymentDateFrom) {
                    this.filteredSubscriptions = this.filteredSubscriptions.filter(s => s.next_payment_date >= filter.nextPaymentDateFrom);
                }

                if (filter.nextPaymentDateTo) {
                    this.filteredSubscriptions = this.filteredSubscriptions.filter(s => s.next_payment_date <= filter.nextPaymentDateTo);
                }
            } catch (e) {
                throw new ApplicationError(e.message, this.getSubscriptionFilters, e);
            }
        },
    },
});